module.exports = __webpack_public_path__ + "static/media/pricingBg.0abb25bc.jpg";